import {
  BitOperators,
  NumberOperators,
  SelectOperators,
  TextOperators,
} from "../components/form/enums";

function getOperatorOptionsForType(type) {
  let operator = TextOperators;
  switch (type) {
    case "bit":
      operator = BitOperators;
      break;
    case "select":
      operator = SelectOperators;
      break;
    case "int":
    case "money":
      operator = NumberOperators;
      break;
    case "text":
    default:
      break;
  }

  return Object.entries(operator).map(([Value, Key]) => ({
    Key: Key,
    Value: Value,
  }));
}

export { getOperatorOptionsForType };
